// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapsible-panel__header[data-v-49a810c7]{font-size:.875rem}.collapsible-panel__chevron[data-v-49a810c7]{transition:all .2s ease-in-out}.collapsible-panel__chevron--open[data-v-49a810c7]{transform:rotate(-180deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
